import { spacing as m } from "./spacing.mjs";
const e = {
  max: "max-content",
  min: "min-content",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  full: "100%"
}, n = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, s = {
  ...m,
  ...e,
  container: n
};
export {
  s as default
};
